<script setup>
/**
 * ModalSimple: Un modal de bootstrap. Este componente solo gestiona los show y hide del modal.
 */
/* global $ */
import {
  provide, ref, useTemplateRef, watch,
} from 'vue';
import ModalBootstrapLayout from './ModalBootstrapLayout.vue';

const props = defineProps({
  modelValue: { type: Boolean, default: false },
  autofocus: { type: Boolean, default: true },
  nivelModal: { type: Number, default: 1 },
});
const emits = defineEmits(['update:modelValue', 'mostrado', 'ocultado']);

const modal = useTemplateRef('modal');
const $modal = ref(null);
const showModal = ref(props.modelValue);

function gestionarModalesStacked() {
  if (props.nivelModal > 1) {
    $modal.value.addClass(`modal-stack-${props.nivelModal}`);
    const backdropActual = $('.modal-backdrop:last');
    backdropActual.addClass(`modal-stack-${props.nivelModal}`);
  }
}

function controlEventosModalBootstrap() {
  $modal.value.off('shown.bs.modal').off('hidden.bs.modal');
  
  $modal.value.on('shown.bs.modal', (e) => {
    // Foco al primer input
    if (props.autofocus) {
      $(e.currentTarget).find('input:first-child').trigger('focus');
    }
    emits('mostrado');
    gestionarModalesStacked();
  });
  $modal.value.on('hidden.bs.modal', () => {
    showModal.value = false;
    emits('update:modelValue', false);
    emits('ocultado');
  });
}

function showModalBootstrap() {
  $modal.value = $(modal.value.$el);
  controlEventosModalBootstrap();
  $modal.value.modal('show');
}

function hideModalBootstrap() {
  $modal.value?.modal('hide');
}

watch(() => props.modelValue, (value) => {
  showModal.value = value;
  if (!value) {
    hideModalBootstrap();
  } else {
    showModalBootstrap();
  }
});

function mostrarModal() {
  showModal.value = true;
  showModalBootstrap();
}

function cerrarModal() {
  hideModalBootstrap();
}

provide('mostrarModal', mostrarModal);
provide('cerrarModal', cerrarModal);
</script>

<template>
  <Teleport to="body">
    <ModalBootstrapLayout ref="modal" v-bind="$attrs" :show="showModal">
      <slot :mostrar="mostrarModal" :cerrar="cerrarModal"></slot>
      <!--
        Estos templates es para pasar los slots que nos pasan a nosotros
        al componente hijo
      -->
      <template v-for="(index, name) in $slots" #[name]="data">
        <slot :name="name" v-bind="data"></slot>
      </template>
    </ModalBootstrapLayout>
  </Teleport>
</template>
